var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEnterTextAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2965 26C11.8788 26 11.525 25.8481 11.235 25.5443C10.945 25.2404 10.8 24.8715 10.8 24.4375V9.125H6C5.58334 9.125 5.22917 8.97273 4.93749 8.66819C4.64583 8.36367 4.5 7.99388 4.5 7.55881C4.5 7.12377 4.64583 6.75521 4.93749 6.45312C5.22917 6.15104 5.58334 6 6 6H18.6C19.0167 6 19.3708 6.15227 19.6625 6.45681C19.9542 6.76133 20.1 7.13112 20.1 7.56619C20.1 8.00123 19.9542 8.36979 19.6625 8.67188C19.3708 8.97396 19.0167 9.125 18.6 9.125H13.8V24.4375C13.8 24.8715 13.6538 25.2404 13.3615 25.5443C13.0691 25.8481 12.7141 26 12.2965 26ZM23.0965 26C22.6788 26 22.325 25.8481 22.035 25.5443C21.745 25.2404 21.6 24.8715 21.6 24.4375V15.375H19.2C18.7833 15.375 18.4292 15.2227 18.1375 14.9182C17.8458 14.6137 17.7 14.2439 17.7 13.8088C17.7 13.3738 17.8458 13.0052 18.1375 12.7031C18.4292 12.401 18.7833 12.25 19.2 12.25H27C27.4167 12.25 27.7708 12.4023 28.0625 12.7068C28.3542 13.0113 28.5 13.3811 28.5 13.8162C28.5 14.2512 28.3542 14.6198 28.0625 14.9219C27.7708 15.224 27.4167 15.375 27 15.375H24.6V24.4375C24.6 24.8715 24.4538 25.2404 24.1615 25.5443C23.8691 25.8481 23.5141 26 23.0965 26Z",
    fill: "#3F5065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnterTextAction);
export default __webpack_public_path__ + "static/media/iconEnterTextAction.9f1c8412.svg";
export { ForwardRef as ReactComponent };